export class CancelHref
{
	hrefs = document.querySelectorAll('[data-s~="CancelHref"]')

    cancel(v)
    {
        v.preventDefault()
        return false
    }

	watch()
	{
        this.hrefs.forEach(e => {
            e.addEventListener("click", (v) => {
                this.cancel(v)
            })
		})
	}
}
